const isMobile = () => {
  let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
  return flag;
};

// 查找实际滚动容器（页面使用 BasicLayout 的 router-view 容器滚动）
const getScrollContainer = () => {
  const selectors = [
    '.router-view-warp',
    '.router-view-warp-mobile',
    '.basic-contex-container'
  ];
  for (const sel of selectors) {
    const el = document.querySelector(sel);
    if (el) return el;
  }
  return document.scrollingElement || document.documentElement || document.body;
};

// 平滑滚动到指定位置（默认 0），支持 rem/px，自动适配窗口或自定义滚动容器
const scrollToTop = (options = {}) => {
  const { top = 0, behavior = 'smooth' } = options;
  const container = getScrollContainer();

  const toPx = (val) => {
    if (typeof val === 'number') return val;
    if (typeof val === 'string') {
      const v = val.trim();
      if (v.endsWith('rem')) {
        const base = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
        return parseFloat(v) * base;
      }
      if (v.endsWith('px')) return parseFloat(v);
      const n = parseFloat(v);
      return isNaN(n) ? 0 : n;
    }
    return 0;
  };
  const topPx = toPx(top);

  const isWindowTarget = (
    container === document.body ||
    container === document.documentElement ||
    container === document.scrollingElement
  );

  try {
    if (isWindowTarget) {
      window.scrollTo({ top: topPx, behavior });
    } else if (typeof container.scrollTo === 'function') {
      container.scrollTo({ top: topPx, behavior });
    } else {
      // Fallback
      container.scrollTop = topPx;
    }
  } catch (e) {
    // 极端环境下的兜底
    container.scrollTop = topPx;
  }
};

// 滚动到指定元素（优先使用 scrollIntoView），支持偏移
const scrollToElement = (el, options = {}) => {
  if (!el) return;
  const { behavior = 'smooth', block = 'start', offset = 0 } = options;
  const container = getScrollContainer();
  const isWindowTarget = (
    container === document.body ||
    container === document.documentElement ||
    container === document.scrollingElement
  );

  try {
    if (typeof el.scrollIntoView === 'function') {
      el.scrollIntoView({ behavior, block });
      if (offset) {
        try {
          if (isWindowTarget) {
            window.scrollBy({ top: offset, behavior });
          } else if (typeof container.scrollBy === 'function') {
            container.scrollBy({ top: offset, behavior });
          } else {
            container.scrollTop += offset;
          }
        } catch (e) {
          container.scrollTop += offset;
        }
      }
      return;
    }
  } catch (e) {}

  // Fallback：计算元素相对滚动容器的目标位置
  const containerRect = container.getBoundingClientRect ? container.getBoundingClientRect() : { top: 0 };
  const elRect = el.getBoundingClientRect ? el.getBoundingClientRect() : { top: 0 };
  const currentTop = isWindowTarget
    ? (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0)
    : container.scrollTop;
  const targetTop = elRect.top - containerRect.top + currentTop + offset;

  try {
    if (isWindowTarget) {
      window.scrollTo({ top: targetTop, behavior });
    } else if (typeof container.scrollTo === 'function') {
      container.scrollTo({ top: targetTop, behavior });
    } else {
      container.scrollTop = targetTop;
    }
  } catch (e) {
    container.scrollTop = targetTop;
  }
};

export default {
  isMobile,
  getScrollContainer,
  scrollToTop,
  scrollToElement
};
